module.exports = __webpack_public_path__ + "static/media/Մարիետա-Բադալյան-Ուռի.011ad786.mp3";